import { APPSTATE_KEY } from 'helpers/constants';
import React, { useEffect, useState } from 'react';
import { Route, Redirect, RouteProps } from 'react-router';
import { useAppState } from 'state/appstate/appstate';
import { useUiState } from 'state/ui-state/ui-state';
import { Currency } from 'api';

const ViewerRouteGuard: React.FunctionComponent<RouteProps> = ({
  children,
  ...props
}) => {
  const [loaded, setLoaded] = useState<boolean>(false);

  const { style, setCurrency } = useAppState((state) => ({
    style: state.styleProduct.style,
    setCurrency: state.setCurrency,
  }));
  const { rehydrated } = useUiState((state) => ({
    rehydrated: state.rehydrated,
  }));

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const currency = params.get('currency');
    if (currency) {
      setCurrency(currency as Currency)
    }
  }, [])

  useEffect(() => {
    if (
      (localStorage.hasOwnProperty(APPSTATE_KEY) && rehydrated) || // state has been rehydrated
      !localStorage.hasOwnProperty(APPSTATE_KEY)
    ) {
      setLoaded(true);
    }
  }, [rehydrated]);

  return loaded ? (
    <Route
      {...props}
      render={() => {
        return style ? children : <Redirect to="/" />;
      }}
    />
  ) : (
    <></>
  );
};

export default ViewerRouteGuard;
